var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg060AddFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 3.00002H14C13.7342 2.99848 13.4787 3.10283 13.29 3.29002L11.59 5.00002H3C2.44772 5.00002 2 5.44773 2 6.00002V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V4.00002C22 3.44773 21.5523 3.00002 21 3.00002ZM4 19V7.00002H12C12.2658 7.00155 12.5213 6.8972 12.71 6.71002L14.41 5.00002H20V19H4ZM13 11V12H14C14.5523 12 15 12.4477 15 13C15 13.5523 14.5523 14 14 14H13V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V14H10C9.44772 14 9 13.5523 9 13C9 12.4477 9.44772 12 10 12H11V11C11 10.4477 11.4477 10 12 10C12.5523 10 13 10.4477 13 11Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg060AddFolder);
export default __webpack_public_path__ + "static/media/060-add-folder.419ce090074e9ab4f58fb61f860748ba.svg";
export { ForwardRef as ReactComponent };